<template>
  <div class="wallet-buttons">
    <transition
      name="fade"
      mode="out-in"
    >
      <c-spinner
        v-if="isLoading"
        class="loading"
      />
      <div
        v-else
        class="content"
      >
        <k-button
          v-if="$can('engagement')"
          data-cy="engagement-wallet-button"
          class="-alternative-button engagement-button"
          no-icon
          @click.native="goTo('Carteira Pontos', 'engajamento')"
        >
          <engagement-coin
            class="info"
            :coin="coin"
            :value="engagement_balance"
          />
        </k-button>

        <k-button
          v-if="$can('awards')"
          data-cy="awards-wallet-button"
          class="-alternative-button award-button"
          no-icon
          @click.native="goTo('Carteira Prêmios', 'premios')"
        >
          <k-icon
            icon="award-star"
            class="wallet-icon"
          />
          <span>Prêmio</span>
          <k-icon
            icon="arrow-right"
            class=""
          />
          <b>{{ userAwards }}</b>
        </k-button>

        <k-button
          v-if="$can('cashback_tab')"
          data-cy="cashback-wallet-button"
          class="-alternative-button award-button"
          no-icon
          @click.native="goTo('Carteira Cashback', 'cashback')"
        >
          <k-icon
            icon="dollar-payments-conversion"
            class="wallet-icon"
          />
          <span>Cashback</span>
          <k-icon
            icon="arrow-right"
            class=""
          />
          <b :class="{'-disabled': cantGetCashback}">{{ userCashbacks }}</b>
        </k-button>
      </div>
    </transition>
  </div>
</template>

<script>
import { COIN, ENGAGEMENT_BALANCE, USER, COMPANY_PERMISSIONS, CONFIG_MAIN } from '@store/types'
import { mapGetters, mapActions } from 'vuex'
import toMoney from '@helpers/toMoney'
import { KButton, KIcon } from '@/components/KaledoComponents'
import EngagementCoin from '../Engagement/Components/EngagementCoin'

export default {
  name: 'WalletButtons',
  components: {
    EngagementCoin,
    KButton,
    KIcon
  },
  data () {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters({
      coin: COIN,
      engagement_balance: ENGAGEMENT_BALANCE,
      user: USER,
      company_permissions: COMPANY_PERMISSIONS,
      config: CONFIG_MAIN
    }),
    userCashbacks () {
      if (!this.user.cashback) return 'R$ 0,00'
      return toMoney(this.user.cashback / 100)
    },
    cantGetCashback () {
      return (this.user.cashback / 100) < 20
    },
    showAwards () {
      if (this.company_permissions.indexOf('awards') !== -1) return true
      return false
    },
    userAwards () {
      if (!this.showAwards) return null
      else if (!this.user.awards_balance) return 'R$ 0,00'
      return toMoney(this.user.awards_balance / 100)
    }
  },
  created () {
    this.initUser()
  },
  methods: {
    ...mapActions({
      getUser: USER
    }),
    async initUser () {
      await this.getUser()
      this.isLoading = false
    },
    goTo (routerName, eventName) {
      window.dataLayer.push({
        event: `${eventName}-carteira-meus-resgates`,
        company_slug: this.config.slug
      })
      this.$router.push({ name: routerName })
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss' scoped>
@import '~@style/reference';

.wallet-buttons {
  height: 106px;
  .loading {
    margin: auto;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    .engagement-button {
      width: 100%;
      font-family: "Averta", Helvetica, Arial, sans-serif;
      text-transform: capitalize;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .award-button {
      width: 100%;
      padding-left: 26px;
      padding-right: 26px;
      font-family: "Averta", Helvetica, Arial, sans-serif;
      .icon {
        top: 8px;
      }
      b {
        color: $base-color;
        font-size: 14px;
        &.-disabled {
          color: $disabled-font;
        }
      }
    }
  }
}
</style>

<style lang='scss'>
@import '~@style/reference';
.wallet-buttons {
  .k-button.-alternative-button.award-button {
    display: flex;
    align-items: center;
    justify-content: center;
    .wallet-icon {
      margin-right: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/WalletButtons.vue